/*----- AUTH Users -------------------------------------------------------------------*/
export default {

  AUTH_REQUEST(state){
    state.status = 'loading'
  },

  AUTH_SUCCESS(state, token) {
    state.status = 'success';
    state.token = token
  },

  AUTH_ERROR(state){
    state.status = 'error'
  },

  setCurrentUser(state, current_user) {
    state.current_user = current_user;
  },

  // Mutation for roles table data
  setRoles(state, roles) {
    state.roles = roles;
  },
  setToken(state, token) {
    state.token = token;
  },
}